import axiosClient from './axiosClient';

const configurationService = {
    get: async () => {
        const response = await axiosClient.get('/admin/configurations');
        return response.data;
    },
    update: async (payload) => {
        const response = await axiosClient.patch('/admin/configurations/update', payload);
        return response.data;
    },
    addState: async (payload) => {
        const response = await axiosClient.patch('/admin/configurations/states', payload);
        return response.data;
    },
    deleteState: async (stateId) => {
        const response = await axiosClient.delete(`/admin/configurations/states/${stateId}`);
        return response.data;
    },
    addCity: async (payload) => {
        const response = await axiosClient.patch('/admin/configurations/cities', payload);
        return response.data;
    },
    deleteCity: async (cityId) => {
        const response = await axiosClient.delete(`/admin/configurations/cities/${cityId}`);
        return response.data;
    }
};

export default configurationService;
